import type { CategoryOfDeviceName, ElementCategory } from "./types";

// Order matters: emergency before lighting, and fire-alarm words are specific so a Bewegungsmelder stays lighting.
const RULES: Array<[RegExp, ElementCategory]> = [
  [/sicherheits\s*leuchte|sicherheitsbeleucht|notleucht|notlicht|rettungszeichen|inotec|ceag/i, "emergencyLighting"],
  [/rauchmelder|w[äa]rmemelder|handmelder|druckknopfmelder|brandmeld|\bbma\b|sirene|signalgeber|blitzleuchte|\brwa\b/i, "fireAlarm"],
  [/\bema\b|einbruch/i, "intruderAlarm"],
  [/datendose|daten|hdmi|wlan|\blan\b|netzwerk|\bcat\.?\s?\d/i, "data"],
  [/erdung|erdanschluss|potentialausgleich|\bpas\b|\bhes\b/i, "earthing"],
  [/steckdose|energiew[üu]rfel|anschluss|\bcee\b/i, "sockets"],
  [/l[üu]fter|motor|kompressor|trockner|pumpe|klima|jalousie|rollladen|\bglt\b|\bzlt\b|t[üo]r|antrieb/i, "buildingServices"],
  [/leuchte|lichtband|downlight|strahler|lampe|schalter|taster|bewegungsmelder|pr[äa]senzmelder|dimmer/i, "lighting"],
];

export const categoryOfDeviceName: CategoryOfDeviceName = (name) =>
  RULES.find(([pattern]) => pattern.test(name))?.[1] ?? "other";
